import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "live-center-page" }
const _hoisted_2 = { class: "type-wrap white-bg radius-middle" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  class: "flex-row-box",
  style: {"flex-wrap":"wrap","width":"100%","justify-content":"flex-start","align-items":"flex-start"}
}
const _hoisted_5 = ["onMouseover", "onMouseleave"]
const _hoisted_6 = { class: "digital-man-title" }
const _hoisted_7 = {
  key: 0,
  class: "flex-row-box",
  style: {"justify-content":"center","height":"50vh"}
}

import { getAppLiveRoomPage } from '@/request/program';
import {ref, onMounted} from 'vue';
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const types = ref([
  {
    label:'全部',
    value:'1'
  },{
    label:'我的收藏',
    value:'2'
  },{
    label:'家居家电',
    value:'3'
  },{
    label:'日用百货',
    value:'4'
  },{
    label:'美妆护肤',
    value:'5'
  },{
    label:'数码产品',
    value:'6'
  },{
    label:'电脑办公',
    value:'7'
  }
])
const activeType = ref('1');
const toggleType = (value) => {
  activeType.value = value;
}

const liveRooms = ref([]);

const chats = ref([
  {
    nickname:'xxxx',
    content:'xccvcxvcafvdsa'
  },{
    nickname:'xxxx',
    content:'xccvcxvcafvdsa'
  },{
    nickname:'xxxx',
    content:'xccvcxvcafvdsa'
  },{
    nickname:'xxxx',
    content:'xccvcxvcafvdsa'
  },{
    nickname:'xxxx',
    content:'xccvcxvcafvdsa'
  },{
    nickname:'xxxx',
    content:'xccvcxvcafvdsa'
  }
])

const getData = ()=>{
  getAppLiveRoomPage({
    pageIndex: 1,
    pageSize: 200,
    liveStatus: 2
  }).then(res=>{
    const {code,data} = res.data;
    if(code==200) {
      liveRooms.value = (data.list ||[]).map(item=>{
        item.hover = false;
        return item;
      });
      setTimeout(()=>{
        liveRooms.value.forEach(room=>{
          generateVideoOptions(room.id, room.liveUrl);
        })
      }, 1000)
    }
  })
}

const generateVideoOptions = (id, url)=>{
  var player = TCPlayer(id, {
      language: 'zh-CN',
      licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1251304744_1/v_cube.license',     
  });
  player.src(url); // url 播放地址
}


onMounted(()=>{
  getData();
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_svgIcon = _resolveComponent("svgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (item) => {
        return (_openBlock(), _createElementBlock("a", {
          class: _normalizeClass(["type-item", activeType.value==item.value && 'active']),
          key: item.value,
          onClick: ($event: any) => (toggleType(item.value))
        }, _toDisplayString(item.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(liveRooms.value, (man, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "digital-man-outer",
          key: idx
        }, [
          _createElementVNode("div", {
            class: "digital-man-wrap radius-middle",
            onMouseover: ($event: any) => (man.hover=true),
            onMouseleave: ($event: any) => (man.hover=false)
          }, [
            _withDirectives(_createVNode(_component_router_link, {
              to: {path:`/live/${man.id}/live-center`},
              target: "_blank",
              class: "btn"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("点击进入直播间")
              ])),
              _: 2
            }, 1032, ["to"]), [
              [_vShow, man.hover]
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("a", { class: "like-btn" }, "收藏", -1))
          ], 40, _hoisted_5),
          _createElementVNode("div", _hoisted_6, _toDisplayString(man.name), 1)
        ]))
      }), 128))
    ]),
    (!liveRooms.value || liveRooms.value.length==0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_svgIcon, {
            iconClass: "nodata",
            width: "180px",
            height: "260px"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})